import { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import TicketTemplateForm from "../TicketTemplateCreate/partials/TicketTemplateForm";

import { useTicketTemplateEdit } from "./hooks";

const TicketTemplateEdit: FC = () => {
  const { form } = useTicketTemplateEdit();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Edit Ticket Template" />
        </Typography.Title>
      </Header>
      <Space />
      <TicketTemplateForm {...form} />
    </>
  );
};

export default TicketTemplateEdit;
